import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Table from 'antd/lib/table';
import { ResponsiveTable } from '../../../common/components/data-display';
import { getContractType } from '../../../common/utils/helpers';
import { contractType, loanStatus, paymentStatus } from '../../../common/enums';
import OpenFileLink from './OpenFileLink';
import { currencyFormatter, formatDateTime } from '../../utils/helpers';
import ReturnOverpayModal  from '../../../features/loan-management/components/ReturnOverpayModal';
import Button from 'antd/lib/button';
import { Col } from 'antd';
import { Link } from 'react-router';
import { accountRoles } from '../../../common/enums';
import PaymentShiftModal from '../../../features/payment-management/components/PaymentShiftModal';

const Column = Table.Column;

const PaymentSummary = props => {
  const { t, loanPaid } = props
  return (
    <div>
      <table>
        <tbody>
          <tr>
            <td style={{ width: "25%" }}>{t('Spolu:')} </td>
            <td style={{ width: "25%", paddingLeft: '5px' }}>{currencyFormatter(props.totalAmount)}  </td>
            <td style={{ width: "50%", paddingLeft: '8px' }}>{currencyFormatter(props.totalAmountUsed)}  </td>
          </tr>
        </tbody>
      </table>
      { props.amountEarlyFee > 0 &&
        <table>
        <tbody>
          <tr>
            <td style={{ width: "25%" }}>{t('Poplatok za predčasné splatenie:')}</td>
            <td style={{ width: "75%" }}>{currencyFormatter(props.amountEarlyFee)}</td>
          </tr>
        </tbody>
        </table>
      }
      <table>
        <tbody>
          <tr>
            <td style={{ width: "25%" }}>{t('Nepoužité splátky:')}</td>
            <td style={{ width: "75%", paddingLeft: '5px' }}>{loanPaid ? currencyFormatter(0) : currencyFormatter(props.totalAmount - props.totalAmountUsed)}</td>
          </tr>
        </tbody>
      </table>
      {
        props.totalAmount - props.totalAmountUsed > 0 &&  
        <table>
          <tbody>
            <tr>
              <td style={{ width: "25%" }}>{t('Preplatok:')}</td>
              {
                <td style={{ width: "75%", paddingLeft: '5px'  }}>{loanPaid ? currencyFormatter((props.totalAmount - props.totalAmountUsed) ) : currencyFormatter(0)}</td>
              }
              
            </tr>
          </tbody>
        </table>
      }
      {
        props.totalReturn > 0 &&
        <table>
          <tbody>
            <tr>
              <td style={{ width: "25%" }}>{t('Vrátený preplatok:')}</td>
              <td style={{ width: "75%" }}>{loanPaid ? currencyFormatter(props.totalReturnUsed ) : currencyFormatter(0)}</td>
            </tr>
          </tbody>
        </table>
      }                     
    </div>
  )
}

const PaymentsList = ({visible, handleModalCancel, showReturnOverpayModal, loanId ,payments, t, isAdmin, loanPaid, returnOverpay,  account, fullAccountName, onShiftPayment, role, amountEarlyFee }) => {

  const [paymentId, setPaymentId] = useState('')
  const [visibleModal, setVisibleModal] = useState(false)

  let totalAmount = 0;
  let totalAmountUsed = 0;
  let totalReturn = 0;
  let totalReturnUsed = 0;

  payments.forEach(p => {
    if(p.status === paymentStatus.ASSIGNED_TO_LOAN){
      totalAmount += parseFloat(p.amount);
      totalAmountUsed += parseFloat(p.amountUsed);
    }
    else if (p.status === paymentStatus.RETURN_OVERPAY){
      p.amount = p.amount
      p.amountUsed = p.amountUsed
      totalReturn += parseFloat(p.amount);
      totalReturnUsed += parseFloat(p.amountUsed);
    }
  })


  totalAmount = Number(totalAmount.toFixed(2));
  totalAmountUsed = Number(totalAmountUsed.toFixed(2));
  totalReturn = Number(totalReturn.toFixed(2));
  totalReturnUsed = Number(totalReturnUsed.toFixed(2));

  let earlyFee = Number(amountEarlyFee).toFixed(2)
  let footerComponent = (
    isAdmin ?
      <div>
        <PaymentSummary
          totalAmount={totalAmount}
          totalAmountUsed={totalAmountUsed}
          totalReturn={totalReturn}
          totalReturnUsed={totalReturnUsed}
          t={t}
          loanPaid={loanPaid}
          amountEarlyFee={earlyFee} />
      </div>
      : null
  )

  const onRowClick = (e) => {
    setPaymentId(e.currentTarget.dataset.id)
    showModal()
    
  }

  const showModal = () => {
    setVisibleModal(!visibleModal)
  }

  return (
    <div>
      {
        ((role === accountRoles.OPERATOR || role === accountRoles.ADMINISTRATOR) && <PaymentShiftModal    
                  account={account}
                  fullAccountName={fullAccountName}
                  onSubmit={onShiftPayment}
                  paymentId={paymentId}
                  onClose={showModal}
                  show={visibleModal}
                >     
                   
        </PaymentShiftModal> )
      }
      
      <section className="payments-list">
      <ResponsiveTable dataSource={payments} rowKey={p => p.id} footer={() => { return footerComponent }} >
        <Column
          title={t('Dátum')}
          dataIndex="createdAt"
          key="createdAt"
          width='25%'
          render={value => formatDateTime(value)}
        />
        <Column
          title={t('Suma celkom')}
          dataIndex="amount"
          key="amount"
          width='25%'
          render={ (value, record) => (
            record.status === paymentStatus.RETURN_OVERPAY ?
            currencyFormatter(Number(value*(-1)))
            : currencyFormatter(value)
          ) }
        />
        <Column
          title={t('Suma využitá')}
          dataIndex="amountUsed"
          key="amountUsed"
          width='25%'
          render={ (value, record) => (
            record.status === paymentStatus.RETURN_OVERPAY ?
            currencyFormatter(Number(value*(-1)))
            : currencyFormatter(value)
          ) }
        />
        {
          ((role === accountRoles.OPERATOR || role === accountRoles.ADMINISTRATOR) && 
            <Column
              title={t('Akcie')}
              dataIndex="status"
              key="status"
              width='25%'
              render={(text, record, index) => (
                text !== paymentStatus.RETURN_OVERPAY ? 
                <a data-id={record.id} onClick={onRowClick}>{t('Presunúť platbu')}</a> 
                : null
            
              )}
            />
          )
        }
            
      </ResponsiveTable>
      
      

      </section >
        {loanPaid && ((totalAmount - totalAmountUsed - totalReturn ).toFixed(2) > 0) && 
          <div>

            <Button size="default" className="btn-inline" onClick={showReturnOverpayModal} >{t('Vrátenie preplatku')}</Button>
            <ReturnOverpayModal
              visible={visible}
              handleModalCancel={handleModalCancel}
              loanId={loanId}
              amount={(totalAmount - totalAmountUsed - totalReturn ).toFixed(2)}
              returnOverpay={returnOverpay}
              iban={account.profileData.iban}
            ></ReturnOverpayModal>
          </div>
        } 
    </div>
    
  );
};

PaymentsList.propTypes = {
  visible: PropTypes.bool.isRequired,
  handleModalCancel: PropTypes.func.isRequired,
  showReturnOverpayModal: PropTypes.func.isRequired,
  loanId: PropTypes.string,
  payments: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  loanPaid: PropTypes.bool.isRequired,
  returnOverpay: PropTypes.func
};

export default translate()(PaymentsList);



// WEBPACK FOOTER //
// ./src/common/components/data-display/PaymentsList.js